export default {
    namespaced: true,
    state: {
        brands: [],
    },
    getters: {
        getAll(state) {
            return state.brands;
        },
    },
    mutations: {
        setAll(state, brands) {
            Object.assign(state, {
                brands,
            });
        },
    },
    actions: {
        async fetchAll(context) {
            const brands = await context.dispatch('api/request', {
                service: 'brand',
                type: 'getAll',
            }, { root: true });

            if (brands) {
                context.commit('setAll', brands);
            }
        },

        async update(context, { id, limited_loe_month, limited_loe_year, full_loe_month, full_loe_year} = {}) {
            const data = {
                id, limited_loe_month, limited_loe_year, full_loe_month, full_loe_year,
            };

            return context.dispatch('api/request', {
                service: 'brand',
                type: 'update',
                data,
            }, { root: true });
        },
    },
};
